import React from "react";
import MarketListPanel from "@features/Market/MainComponents/MarketListPanel";

const MarketDropDown = ({ handlePopoverClose }) => (
  <MarketListPanel variant="popover" onNavigate={handlePopoverClose} />
);

export default MarketDropDown;
